import store from '@/store'
import router from '@/router'
import axios from 'axios'

import { getCookie, removeCookie } from '@/util/cookies'
const msgMethods = ['post', 'put', 'patch', 'delete']
axios.defaults.baseURL = process.env.VUE_APP_BASE_API // url = base url + request url
// create an axios instance
const service = axios.create({
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 600000, // request timeout
})

// request interceptor
service.interceptors.request.use(
  (config) => {
    config.baseURL = process.env[config.base]
    const token = getCookie()
    if (token) {
      config.headers.Authorization = `${token.token_type} ${token.token}`
    }

    return config
  },
  (error) => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  },
)

// response interceptor
// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data
    const successMSg = res?.message
    if (successMSg) {
      store.commit('app/SET_ALERT_TXT', {
        timeout: 3700,
        type: 'success',
        txt: successMSg,
      })
      store.commit('app/SET_ALERT', true)
    } else if (response.config.url !== 'login' && msgMethods.includes(response?.config?.method)) {
      store.commit('app/SET_ALERT_TXT', {
        timeout: 3700,
        type: 'success',
        txt: response?.config?.method === 'post' ? 'Creado con éxito' : response?.config?.method === 'delete' ? 'Eliminado con éxito' : 'Modificado con éxito',
      })
      store.commit('app/SET_ALERT', true)
    }

    return res
  },
  async (error) => {
    const errorStatus = error?.response?.status
    console.log('err' + error) // for debug
    console.log('status ' + errorStatus) // for debug
    if (errorStatus === 401) {
      await removeCookie()
      window.localStorage.clear()
      router.push({ path: '/ingresar' }).catch((e) => { console.log(e) })
    }
    const errorMSg = error?.response?.data?.error?.message
    if (errorMSg) {
      if (error.response.status === 404) {
        router.push({ path: '/' }).catch((e) => { console.log(e) })
      }
      store.commit('app/SET_ALERT_TXT', {
        timeout: 3700,
        type: 'error',
        txt: errorMSg || 'Error',
      })
      store.commit('app/SET_ALERT', true)
    } else {
      store.commit('app/SET_ALERT_TXT', {
        timeout: 3700,
        type: 'error',
        txt: 'Error!',
      })
      store.commit('app/SET_ALERT', true)
    }
    return Promise.reject(error)
  },
)

export default service
